/**
 * 패널 제품 테이블 아이템 형태 정의
 * 서버 응답을 테이블에서 사용할 수 있는 형태로 변환하기 위한 구조 정의
 * 
 * 주의: 패널 제품의 경우 서버 응답을 그대로 사용하므로 변환 로직이 없습니다.
 * 이 파일은 향후 확장을 위해 구조만 정의합니다.
 */

/**
 * 테이블에서 사용하는 패널 제품 아이템의 필드 구조
 * 서버 응답 구조와 동일하므로 별도 변환이 필요 없습니다.
 */
export const PANEL_PRODUCT_TABLE_ITEM_SCHEMA = Object.freeze({
  // 서버 응답을 그대로 사용하므로 스키마는 참고용
});

/**
 * 서버 응답 데이터를 테이블 아이템 형태로 변환하는 함수
 * 패널 제품의 경우 변환이 필요 없으므로 그대로 반환합니다.
 * @param {Object} serverItem - 서버에서 받은 패널 제품 객체
 * @returns {Object} 테이블에서 사용할 수 있는 형태의 아이템 객체 (변환 없음)
 */
export function transformToPanelProductTableItem(serverItem) {
  if (!serverItem) {
    return null;
  }

  // 패널 제품은 서버 응답을 그대로 사용
  return serverItem;
}

/**
 * 서버 응답 배열을 테이블 아이템 배열로 일괄 변환하는 함수
 * @param {Array<Object>} serverItems - 서버에서 받은 패널 제품 객체 배열
 * @returns {Array<Object>} 테이블에서 사용할 수 있는 형태의 아이템 객체 배열
 */
export function transformToPanelProductTableItems(serverItems) {
  if (!Array.isArray(serverItems)) {
    return [];
  }

  return serverItems
    .map(item => transformToPanelProductTableItem(item))
    .filter(item => item !== null);
}

